module.exports = __webpack_public_path__ + "static/media/480.1c4b33f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-irrigation/light/480.png
// module id = 2212
// module chunks = 2